/*
 * File: ForgotPassword.jsx
 * Project: frontend
 * File Created: Monday, 1st May 2023 5:07:21 pm
 * Author: Sharath Puranik (sharath.puranik@stylumia.com)
 * -----
 * Last Modified: Friday, 30th August 2024 1:05:57 am
 * Modified By: Sharath Puranik (sharath.puranik@stylumia.com>)
 * -----
 * Copyright - 2024, Stylumia Intelligence Technology Pvt Ltd
 */
import React, { Component } from "react";

import axios from "axios";
import Lottie from "lottie-react";

import { useLocation } from "react-router-dom";

import {
  redirectMain,
  password_forgot_endpoint,
  AUTH_CONSTANTS
} from "../../constants/constants";
import Input from "../Input/index";
import astronaut from "../../animations/baby_astronaut.json";
import get_host from "../../utils";
import { usersAuthLog } from "../../utils/loginLogs";
import { LoggerContext } from "../../loggers";
import { useDeviceIdentification } from "../../hooks/useDeviceIdentification";
import {
  MIXPANEL_FORGOT_PASSWORD_EVENT,
  MIXPANEL_FORGOT_PASSWORD_PAGE_NAME
} from "../../loggers/constant";

import MailIcon from "../../assests/mail.svg";

import Template from "./template";
import "./style.css";

class ForgotPassword extends Component {
  static contextType = LoggerContext;

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      backendBroke: false,
      error: { email: false, text: false },
      finalError: false,
      loading: false,
      err_message: "",
      email_sent: false
    };

    this.handlekeyPress = this.handlekeyPress.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getEmail = this.getEmail.bind(this);
  }

  componentDidMount() {
    // logging page view
    this.context.mixpanel.pageView(MIXPANEL_FORGOT_PASSWORD_PAGE_NAME);
  }

  handlekeyPress(e) {
    if (e.keyCode === 13 && this.state.email !== "") {
      this.handleSubmit();
    }
  }

  handleSubmit() {
    if (this.state.loading) {
      return;
    }
    console.log("Starting handleSubmit");
    const search = this.props.location.search;
    const redirect =
      new URLSearchParams(search).get("redirect") || redirectMain;

    sessionStorage.setItem("userEmailId", this.state.email);
    this.setState({
      loading: true
    });
    console.log("Calling getVisitorId");
    this.props
      .getVisitorId()
      .then((visitorId) => {
        console.log("Received visitor ID:", visitorId);
        if (!visitorId) {
          console.log("No visitor ID received");
          // logging event
          this.context.mixpanel.log(
            this.state.err_message !== "",
            MIXPANEL_FORGOT_PASSWORD_EVENT,
            {
              email: this.state.email,
              fingerprintID: this.state.fingerID
            }
          );
          this.setState({
            backendBroke: true,
            loading: false
          });
          return;
        }
        if (this.state.email) {
          const formData = new FormData();
          formData.append("email", this.state.email);
          formData.append("redirect", redirect);
          formData.append("fingerprint", visitorId);

          const authLogObjOne = {
            email: this.state.email,
            serviceCategory: "Auth",
            service: "Login",
            eventCategory: "Forgot Password",
            eventAction: "Submit",
            eventLabel: "User Entered Details",
            fingerprintID: visitorId,
            eventValue: {
              email: this.state.email,
              fingerprint: visitorId
            }
          };

          usersAuthLog(authLogObjOne);

          this.setState({
            loading: true
          });
          const start = performance.now();
          axios
            .post(get_host(password_forgot_endpoint), formData)
            .then((res) => {
              if (res.status === 200) {
                this.setState({
                  email_sent: true,
                  err_message: "",
                  loading: false
                });

                const authLogObj = {
                  email: this.state.email,
                  serviceCategory: "Auth",
                  service: "Login",
                  eventCategory: "Forgot Password",
                  eventAction: "Submit",
                  eventLabel: "Password Reset Link Sent",
                  fingerprintID: visitorId,
                  eventValue: {
                    status_code: res.status,
                    time_taken: performance.now() - start,
                    fingerprint: visitorId
                  }
                };

                usersAuthLog(authLogObj);
              }
            })
            .catch((err) => {
              this.setState({
                err_message:
                  err.response && err.response.data !== undefined
                    ? err.response.data.detail || err.response.data.desccription
                    : err.message,
                loading: false
              });

              const authLogObj = {
                email: this.state.email,
                serviceCategory: "Auth",
                service: "Login",
                eventCategory: "Forgot Password",
                eventAction: "Submit",
                eventLabel: "Invalid Email",
                fingerprintID: visitorId,
                eventValue: {
                  status_code: err.response.status,
                  time_taken: performance.now() - start,
                  fingerprint: visitorId
                }
              };

              usersAuthLog(authLogObj);
            })
            .finally(() => {
              // logging event
              this.context.mixpanel.log(
                this.state.err_message !== "",
                MIXPANEL_FORGOT_PASSWORD_EVENT,
                {
                  email: this.state.email,
                  fingerprintID: visitorId
                }
              );
              this.setState({
                loading: false
              });
            });
        }
      })
      .catch((error) => {
        console.error("Error getting visitor ID:", error);
        this.setState({
          backendBroke: true,
          loading: false
        });
      });
  }

  getEmail({ value }) {
    this.setState({ email: value, err_message: "" });
  }

  handleError = (errorState, er) => {
    let x;
    this.setState(
      (state) => {
        x = state.error;
        x[errorState] = er;
        return { error: x };
      },
      () => {
        let flag;
        for (x in this.state.error) {
          if (this.state.error[x]) {
            flag = true;
          }
        }
        if (flag === true) {
          this.setState({ finalError: true });
        } else {
          this.setState({ finalError: false });
        }
      }
    );
  };

  render() {
    const backendBroke =
      "Something seems to be broken. Please try after some time.";
    const errorText =
      "There was an error with your e-mail/password combination. Please try again.";
    const isResetDisabled =
      this.state.email === "" || this.state.loading || this.state.error.email;
    return (
      <Template>
        <div className="login-welcome-container" style={{ display: "grid" }}>
          <div className="header-container">
            <span className="login-welcome-text">
              Welcome to Consumer Intelligence
            </span>
            <br />
            <span className="login-welcome-sub-text">
              We suggest using the{" "}
              <span className="font-weight-500">
                email address you use at work.
              </span>
            </span>
          </div>
          <div className="" style={{ maxWidth: "368px", width: "100%" }}>
            {this.state.backendBroke ? (
              <span className="error-msg" style={{ textAlign: "start" }}>
                {backendBroke}
              </span>
            ) : (
              ""
            )}
            {this.state.wrongPassword ? (
              <span className="error-msg" style={{ textAlign: "start" }}>
                {errorText}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
        <br />
        <div /* style={{width:"95%"}} */ onKeyDown={this.handlekeyPress}>
          <Input
            className="input.button"
            leftChild={<img alt="" className="icon" src={MailIcon} />}
            label="EMAIL"
            placeholder="Enter your work email address"
            value={this.state.email}
            onChange={(e) => this.handleChangeemail(e)}
            validation="email"
            errorMessage="Enter a valid email address"
            getInputValue={this.getEmail}
            error={this.state.error}
            disabled={!!this.state.email_sent}
            handleError={this.handleError}
            type={AUTH_CONSTANTS.EMAIL_INPUT.TYPE}
            name={AUTH_CONSTANTS.EMAIL_INPUT.NAME}
            autoComplete={AUTH_CONSTANTS.EMAIL_INPUT.AUTO_COMPLETE}
          />
          {this.state.err_message && (
            <small style={{ color: "red" }}>{this.state.err_message}</small>
          )}
          {this.state.email_sent ? (
            <div className="check_email_container">
              <Lottie
                style={{ height: "111px" }}
                animationData={astronaut}
                loop
              />
              <div className="check_email">Check Email!!</div>
              <div className="signed_in_for_two_weeks">
                Click on the link and reset your password
              </div>
            </div>
          ) : (
            <div className="options-buttons-container">
              <div>
                {this.state.loading ? (
                  <button
                    type="button"
                    className="inactive-button without-password"
                    disabled
                  >
                    Please wait...
                  </button>
                ) : this.state.finalError ? (
                  <button
                    type="button"
                    className="inactive-button without-password"
                    disabled
                  >
                    Reset Password
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={this.handleSubmit}
                    className={
                      !isResetDisabled
                        ? "without-password click-ripple-effect"
                        : "inactive-button"
                    }
                    disabled={isResetDisabled}
                  >
                    Reset password
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="login-contact-us-container">
          <div>
            New to Stylumia?&nbsp;{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.stylumia.ai/get-a-demo/"
            >
              {" "}
              Sign up for a demo{" "}
            </a>
          </div>
        </div>
      </Template>
    );
  }
}

function WithDeviceIdentification(Component) {
  return function WrappedComponent(props) {
    const location = useLocation();
    const { getVisitorId } = useDeviceIdentification();
    return (
      <Component getVisitorId={getVisitorId} location={location} {...props} />
    );
  };
}

export default WithDeviceIdentification(ForgotPassword);
